import * as z from "zod/v4";

export const productToClassify = z.object({
  productName: z.string().min(1),
  productDescription: z.string().optional(),
  materials: z.string().optional(),
  endUse: z.string().optional(),
  isFinishedGood: z.boolean().optional(),
});
export type ProductToClassify = z.infer<typeof productToClassify>;

export const productClassification = z.object({
  productType: z.string(),
  htsCode: z.string(),
  confidence: z.enum(["high", "medium", "low"]),
  reasonForClassification: z.string(),
});
export interface ProductClassification
  extends z.infer<typeof productClassification> {}

export const classifyProducts = {
  name: "classifyProducts" as const,
  input: z.object({ teamId: z.string(), products: z.array(productToClassify) }),

  output: z.object({
    classifications: z.array(
      z.object({
        product: productToClassify,
        classification: productClassification.nullable(),
      }),
    ),
    classifiedAt: z.date(),
  }),
};
